import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import {
	CodigoPostal,
	InputError,
	InputGroupWrapper,
	InputWrapper,
	TextInputExtended,
} from 'src/components';
import { OneFormState } from 'src/types';

export const EmpresaInfoComponent = () => {
	const { register } = useFormContext();
	const { formInfo } = useSelector((state: OneFormState) => state);

	// Nombre de la empresa
	const [inputValueName, setInputValueName] = useState('');
	const [pristineName, setPristineName] = useState(true);
	const [errorName, setErrorName] = useState(false);
	const regExpName = /[a-zA-Z]/gi;

	const handleChangeName = (e: any) => {
		setInputValueName(e.target.value);
		setPristineName(false);
	};

	useEffect(() => {
		if (!pristineName && inputValueName.match(regExpName) === null) {
			setErrorName(true);
		} else {
			setErrorName(false);
		}
	}, [inputValueName, pristineName]);

	// CIF
	const [inputValueCIF, setInputValueCIF] = useState('');
	const [pristineCIF, setPristineCIF] = useState(true);
	const [errorCIF, setErrorCIF] = useState(false);
	const regExpCIF = /[A-Z]\d{8}/gi;

	const handleChangeCIF = (e: any) => {
		setInputValueCIF(e.target.value);
		setPristineCIF(false);
	};

	useEffect(() => {
		if (!pristineCIF && inputValueCIF.match(regExpCIF) === null) {
			setErrorCIF(true);
		} else {
			setErrorCIF(false);
		}
	}, [inputValueCIF, pristineCIF]);

	return (
		<>
			<InputGroupWrapper className="empresa_info-wrapper">
				<InputWrapper
					className="prefijo_telefono-input-wrapper"
					notALayer={formInfo.notALayer}
					paddingTop="0"
					paddingBottom="0"
				>
					<TextInputExtended
						name="businessName"
						label="Razón Social"
						isFloating
						innerRef={register({
							required: {
								value: true,
								message: 'Requerido',
							},
							pattern: {
								value: regExpName,
								message: 'Solo se aceptan letras',
							},
						})}
						onChange={e => handleChangeName(e)}
						required
					/>
					{errorName && (
						<InputError className="input-error">
							Solo se aceptan letras
						</InputError>
					)}
				</InputWrapper>

				<InputWrapper
					className="prefijo_telefono-input-wrapper"
					notALayer={formInfo.notALayer}
					paddingTop="0"
					paddingBottom="0"
				>
					<TextInputExtended
						name="CIF"
						label="CIF"
						isFloating
						innerRef={register({
							required: {
								value: true,
								message: 'Requerido',
							},
							pattern: {
								value: regExpCIF,
								message: 'A00000000',
							},
						})}
						onChange={e => handleChangeCIF(e)}
						required
					/>
					{errorCIF && (
						<InputError className="input-error">
							Ejemplo: A00000000
						</InputError>
					)}
				</InputWrapper>

				<CodigoPostal />
			</InputGroupWrapper>
		</>
	);
};
